const CookieConstants = {
  shareId: 'shareId',
  token: 'token',
  refreshToken: 'refreshToken',
}

export {
  CookieConstants
}